import React, { useEffect, useState } from "react";
import { Alert, Button, Card, CardBody, Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { getAppsData, logoutUser } from "./slices/thunks";
import { useNavigate } from "react-router-dom";

const Apps2 = () => {
  const dispatch: any = useDispatch();
  let navigate = useNavigate();

  const [apps, setApps] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const dashboardState = (state: any) => state;
  const dashboardData = createSelector(dashboardState, (state) => ({
    appsData: state.Dashboard.appsData,
    error: state.Dashboard.error,
  }));
  const { appsData, error } = useSelector(dashboardData);

  const logOut = () => {
    dispatch(logoutUser());
    navigate("/login");
  };
  useEffect(() => {
    dispatch(getAppsData()).finally(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    if (loading) return;

    if (typeof appsData === "string" && appsData.trimStart().startsWith("<")) {
      console.log("HTML response received, redirecting to login");
      navigate("/login");
    } else if (appsData?.code === "000") {
      setApps(appsData);
      if (appsData.appData.length === 1) {
        window.location.href = appsData.appData[0].appAuthenticationUrl;
      }
    } else if ((appsData?.code && appsData.code !== "000") || error) {
      console.log("inside elif error");
      navigate("/login");
    }
  }, [appsData, error, navigate, loading]);

  document.title = "Accueil | Business Online";

  return (
    <React.Fragment>
      <Row className="g-0 dashboard">
        <Col lg={12} xs={12}>
          <Alert
            color="primary"
            className="alert-label-icon rounded-label material-shadow"
            transition={{ timeout: 150 }}
          >
            <i className="ri-user-3-line label-icon"></i>
            <strong>Bienvenue {apps?.fullName}</strong> - Sur votre espace
            Business Online
            <Button
              color="primary"
              className="btn-label right rounded-pill btn-sm"
              onClick={() => logOut()}
            >
              <span>déconnexion </span>
              <i className="ri-logout-circle-r-line fs-16"></i>
            </Button>
          </Alert>
        </Col>
        <Col lg={12} xs={12}>
          <div className="apps-container">
            {loading ? null : apps?.appData ? (
              apps.appData.map((appsItem: any, index: number) => (
                <Card key={index}>
                  <CardBody>
                    <img src={appsItem.iconName} alt={appsItem.title} />
                    <h2>{appsItem.title}</h2>
                    <p>{appsItem.description}</p>
                    <hr />
                    <Button
                      color="success"
                      className="w-100"
                      onClick={() => {
                        window.open(appsItem.appAuthenticationUrl, "_blank");
                      }}
                    >
                      ENTRER
                    </Button>
                  </CardBody>
                </Card>
              ))
            ) : (
              <>
                <Card className="disabled">
                  <CardBody>
                    <img src={"cash.png"} alt="Cash" />
                    <h2>CASH</h2>
                    <p>
                      Consultez vos comptes et gérez vos opérations en toute
                      sécurité.
                    </p>
                    <hr />
                    <p className="contact">
                      Afin d'activer ce service, veuillez vous adresser à notre
                      équipe support au 05 22 49 85 85.
                    </p>
                  </CardBody>
                </Card>
                <Card className="disabled">
                  <CardBody>
                    <img src={"trade.png"} alt="Trade" />
                    <h2>TRADE</h2>
                    <p>Traitez vos opérations de Trade finance en un clic.</p>
                    <hr />
                    <p className="contact">
                      Afin d'activer ce service, veuillez vous adresser à notre
                      équipe support au 05 22 49 85 85.
                    </p>
                  </CardBody>
                </Card>
              </>
            )}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Apps2;
